import type { Address } from 'viem';
import { create } from 'zustand';

type OneClickTradingState = {
  /** Whether the 1CT wallet has been created (record exists in IndexedDB) */
  created: boolean;
  /** Whether delegation to the 1CT wallet has been enabled on-chain */
  enabled: boolean;
  /** Whether we have successfully checked the current wallet status */
  hasCheckedStatus: boolean;
  owner?: Address;
  oneClickWalletAddress?: Address;
  /**
   * Merge partial state updates coming from wallet / status checks.
   */
  setStateFromWallet: (payload: {
    created?: boolean;
    enabled?: boolean;
    hasCheckedStatus?: boolean;
    owner?: Address;
    oneClickWalletAddress?: Address;
  }) => void;
  reset: () => void;
};

export const useOneClickTradingStore = create<OneClickTradingState>((set) => ({
  created: false,
  enabled: false,
  hasCheckedStatus: false,
  owner: undefined,
  oneClickWalletAddress: undefined,
  setStateFromWallet: (payload) =>
    set((prev) => ({
      created: payload.created ?? prev.created,
      enabled: payload.enabled ?? prev.enabled,
      hasCheckedStatus: payload.hasCheckedStatus ?? prev.hasCheckedStatus,
      owner: payload.owner ?? prev.owner,
      oneClickWalletAddress:
        payload.oneClickWalletAddress ?? prev.oneClickWalletAddress,
    })),
  reset: () =>
    set({
      created: false,
      enabled: false,
      hasCheckedStatus: false,
      owner: undefined,
      oneClickWalletAddress: undefined,
    }),
}));


